import { Building2 } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

/**
 * Shown when a Careforce super user opens Active Lines while their active
 * organization is a customer org.
 *
 * They do have access — the route gate is membership-based — but the board is
 * global / cross-tenant and helpcare gates it on the active-org claim, so the
 * request would 403. The query stays disabled in that case, so this explains the
 * empty page instead of leaving a spinner or a generic error on screen.
 *
 * The nav entry and the OrgHome card are hidden outside Careforce, so this is
 * reached by a persisted tab, a bookmark, or back-navigation rather than by
 * clicking — the safety net, not the main path.
 *
 * Deliberately not `variant="destructive"`: nothing failed, and this is not a
 * denial. Everyone who sees this is a Careforce admin, so the switch is always
 * available to them — hence the second line, which keeps it from being a dead
 * end. Internal-facing copy: no customer ever reaches it.
 *
 * TEMPORARY — remove when the board returns org-scoped data, at which point a
 * customer org shows that org's own lines rather than nothing.
 */
export function CareforceOrgNotice() {
  return (
    <div className="h-full overflow-auto px-6 py-4">
      <Alert>
        <Building2 className="h-4 w-4" />
        <AlertTitle>Not yet available for this organization</AlertTitle>
        <AlertDescription>
          Active Lines currently shows the shared outbound phone-line pool
          across all of Careforce. Switch to the Careforce organization to view
          it.
        </AlertDescription>
      </Alert>
    </div>
  )
}
